import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setStepCreateSurvey } from 'store/actions/survey';

const UndoRedo = ({ form, onClick }) => {
  const dispatch = useDispatch();
  const { history_create_survey, step_create_survey } = useSelector((state) => state.survey);

  const handleUndo = () => {
    if (history_create_survey.length > 1 && step_create_survey > 0) {
      const prevStep = step_create_survey - 1 ?? history_create_survey.length - 1;
      dispatch(setStepCreateSurvey(prevStep));
      form.setValues(JSON.parse(history_create_survey[prevStep]));
      onClick();
    }
  };

  const handleRedo = () => {
    if (step_create_survey < history_create_survey.length - 1) {
      const nextStep = step_create_survey + 1 ?? history_create_survey.length - 1;
      dispatch(setStepCreateSurvey(nextStep));
      form.setValues(JSON.parse(history_create_survey[nextStep]));
      onClick();
    }
  };

  return (
    <div className="flex items-center gap-4">
      <img
        className={`${history_create_survey.length > 1 && step_create_survey > 0 ? 'cursor-pointer' : 'opacity-50'}`}
        onClick={handleUndo}
        src={require('assets/resources/Undo.svg').default}
        alt="undo icon"
        width={24}
        height={24}
      />
      <img
        className={`${step_create_survey < history_create_survey.length - 1 ? 'cursor-pointer' : 'opacity-50'}`}
        onClick={handleRedo}
        src={require('assets/resources/Redo.svg').default}
        alt="redo icon"
        width={24}
        height={24}
      />
    </div>
  );
};

export default React.memo(UndoRedo);
